
export default (distribution: number[][], scoreRef: HTMLElement, bar: number, instant?: boolean) => {
    if (!scoreRef || !distribution) return;
    const currentLine = distribution.findIndex(system => {
        return system.indexOf(bar) !== -1;
    });
    const systemHeight = (scoreRef.scrollHeight - 50) / distribution.length;
    scoreRef.scrollTo({
        top: 20 + systemHeight * currentLine,
        left: 0,
        behavior: instant ? undefined : "smooth",
    });
};
